import { render, staticRenderFns } from "./TutorialPractice.vue?vue&type=template&id=8b0454fc&scoped=true&"
import script from "./TutorialPractice.vue?vue&type=script&lang=js&"
export * from "./TutorialPractice.vue?vue&type=script&lang=js&"
import style0 from "./TutorialPractice.vue?vue&type=style&index=0&id=8b0454fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0454fc",
  null
  
)

export default component.exports